import React from 'react';

import { ChevronRight } from '@mui/icons-material';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import RedirectLink from 'pages/Search/components/RedirectLink';

import useStyles from './styles';

interface Props {
    className?: string;
    items: {
        link: string;
        label: string;
        onClick?: React.MouseEventHandler;
        disabled?: boolean;
    }[];
}

const Breadcrumbs: React.FC<Props> = (props) => {
    const { className, items } = props;
    const { classes } = useStyles();
    return (
        <MuiBreadcrumbs
            separator={<ChevronRight className={classes.separator} />}
            classes={{ root: classes.root, ol: classes.ol }}
            className={className}
        >
            {items.map(({ link, label, disabled, onClick }, index) => (
                <RedirectLink
                    key={index}
                    to={link}
                    label={label}
                    active={!disabled}
                    className={classes.link}
                    onClick={onClick}
                />
            ))}
        </MuiBreadcrumbs>
    );
};

export default Breadcrumbs;
